import { useEffect } from "react";
import { isSameDay } from "date-fns";

export const useCenterCarousel = (swiperRef, selectedDate, days) => {
  useEffect(() => {
    if (!swiperRef.current) return;

    const swiper = swiperRef.current.swiper;
    const selectedDayIndex = days.findIndex((day) =>
      isSameDay(day.date, selectedDate)
    );

    if (selectedDayIndex === -1) return;

    const slideWidth = swiper.slides[0]?.offsetWidth || 1;
    const spaceBetween = swiper.params.spaceBetween || 0;
    const slidesPerView = Math.floor(
      (swiper.width + spaceBetween) / (slideWidth + spaceBetween)
    );
    const halfSlidesPerView = Math.floor(slidesPerView / 2);

    let targetSlide;

    if (selectedDayIndex <= halfSlidesPerView) {
      targetSlide = 0;
    } else if (selectedDayIndex >= days.length - halfSlidesPerView) {
      targetSlide = Math.max(0, days.length - slidesPerView);
    } else {
      targetSlide = Math.max(
        0,
        selectedDayIndex - Math.ceil(slidesPerView / 2) + 1
      );
    }

    swiper.slideTo(targetSlide, 300, false);
  }, [selectedDate, days, swiperRef]);
};
